import {
	DevCycleUser,
	useDevCycleClient,
	useIsDevCycleInitialized,
	useVariableValue
} from "@devcycle/react-client-sdk";
import usePropelAuth from "./usePropelAuth";

export const useDevCycleSdk = () => ({
	playlists: useVariableValue("playlist", false),
	announcements: useVariableValue("announcements", false),
	archiveUserFlow: useVariableValue("archive-user-flow", true),
	contentCreationUpdates: true,
	hideCreationButtons: useVariableValue("hide-creation-buttons", true),
	filterSettingsPersistence: true,
	teamProgress: true,
	trainingPool: true,
	disableAutoAssign: true,
	meiliSearchIntegration: true,
	bulkRescheduleOverdue: true,
	courseBulkEnrollment: true,
	playlistBasedCerts: useVariableValue("playlist-based-certs", false),
	dueDateAssignments: useVariableValue("due-date-assignments", false),
	monthEndReport: true,
	monthlyReportDistributionList: useVariableValue("monthly-report-distribution-list", false),
	pauseStreak: true,
	lessonLinksAttachments: useVariableValue("lesson-links-attachments", false),
	newHomeScreen: true,
	useApp2: true,
	frankAi: useVariableValue("frank-ai", false),
	leaderboards: useVariableValue("use-leaderboards", false)
});

export const useDevCycleIdentifier = (): void => {
	const devCycleClient = useDevCycleClient();
	const isDevCycleInitialized = useIsDevCycleInitialized();
	const {authUser, authInfo} = usePropelAuth();

	if (!authUser || isDevCycleInitialized) return;

	const devCycleUser: DevCycleUser = {
		user_id: authUser.userId ?? "unidentified-user",
		isAnonymous: false,
		email: authUser.email ?? "",
		customData: {
			orgId: authInfo.orgHelper?.getOrgIds()?.[0] ?? ""
		}
	};

	devCycleClient.identifyUser(devCycleUser, error => {
		if (error) console.error("devCycleClient.identifyUser", error);
	});
};

export default useDevCycleSdk;
